import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { categoryApi } from './services/category';
import { customersApi } from './services/customers';
import sessionReducer from './slices/sessionSlice';

export const store = configureStore({
    reducer: {
        session: sessionReducer,
        [customersApi.reducerPath]: customersApi.reducer,
        [categoryApi.reducerPath]: categoryApi.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(customersApi.middleware, categoryApi.middleware)
});
// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
